import React, { forwardRef, useRef, useEffect, useState, useImperativeHandle } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Modal } from 'bootstrap';
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Chart } from "react-google-charts";
import TapIcon from '../../services/TapIcon';
import ApplicationLayout from '../../layouts/ApplicationLayout';
import TapNavTabs from '../../components/ui/TapNavTabs';
import PageHeader from '../includes/PageHeader';
import ProjectData from './ProjectData';
import ProjectTimeLineChart from './ProjectTimeLineChart';
import ProjectDocument from './ProjectDocument';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import HttpAPICall from '../../services/HttpAPICall';
import ProjectTicketData from './ProjectTicketData';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import swal from "sweetalert";
import UpdateMultipleTicketModal from './UpdateMultipleTicketModal';
import { Helmet } from 'react-helmet';
import download from '../../services/DownloadFile';
import ProjectEditModal from './ProjectEditModal';
import EditBudgetModal from './EditBudgetModal';
import WorklogList from '../hrm/worklog/WorklogList';


const ProjectDetail = forwardRef((props, ref) => {

    const multipleTicketEditModelRef = useRef();
    const projectTicketDataRef = useRef();
    const projectTimeChartRef = useRef();
    const editProjectModalRef = useRef();
    const editBudgetModalRef = useRef();

    const { id } = useParams();


    const accessToken = useSelector(state => state.auth.access_token);
    const permissions = useSelector(state => state.app.acl_info && state.app.acl_info.permissions ? state.app.acl_info.permissions : []);
    const allPermissions = useSelector(state => state.app.acl_info ? state.app.acl_info : []);

    const projectUrl = IAM_API_BASE_URL_2 + "/project/detail/_replace_id";
    const projectDeleteUrl = IAM_API_BASE_URL_2 + "/project/delete/__pid";

    const [currentTab, setCurrentTab] = useState(0);
    const [loadedTabs, setLoadedTabs] = useState([]);
    const [projectDetails, setProjectDetails] = useState(null)
    const [project_detail_loading, setProject_detail_loading] = useState(false)
    const [project_download_loading, setProject_download_loading] = useState(false)

    const [checkTicketids, setCheckTicketids] = useState([]);
    const [ticket_view_data, setTicket_view_data] = useState([])
    const [ticketHeader, setTicketHeader] = useState('')
    const [current_activity_id, setCurrent_activity_id] = useState(null)

    const [ticketListAddBoard, setTicketListAddBoard] = useState('ticketListShow');

    const [reportDownloading, setReportDownloading] = useState(false)
    const [listing_loading, setListing_loading] = useState(false)
    const [minimizeTable, setMinimizeTable] = useState(false)
    const [ticketDownloading, setTicketDownloading] = useState(false)

    useEffect(() => {
        getProjectDetail();
    }, []);


    /**
     * 
     * @ticket_list_refresh default N 
     * @ticket_chart_refresh default:N
     */
    const refreshData            = (ticket_list_refresh='N',ticket_chart_refresh='N')    => {
        if (projectTicketDataRef.current && ticket_list_refresh == 'Y') {
            projectTicketDataRef.current.refreshData();
            getProjectDetail('Y');
        } else if (projectTimeChartRef.current && ticket_chart_refresh == 'Y') {
            getProjectDetail('Y', 'Y');
        } else {
            getProjectDetail('Y');
        }
    };

    const deleteProjectHandler = () => {
        if (projectDetails) {
            let project_id = projectDetails.id;
            if (permissions.includes('iam-project-delete')) {
                swal({
                    title: "Delete", dangerMode: true, buttons: ["No", "Yes"], icon: "warning",
                    text: "Are you sure want to delete this project, This action cannot be reversed, Are you sure you want to proceed.",
                }).then(willDelete => {
                    if (willDelete) {
                        HttpAPICall.withAthorization('DELETE', projectDeleteUrl.replace('__pid', project_id),
                            accessToken, null, null, (response) => {
                                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                                closeProjectTicket();
                            }).then(() => {

                            });
                    }
                });
            } else {
                toast.error('You are not authorized to delete project', { position: toast.POSITION.TOP_RIGHT })
            }
        }
    }

    const  editBudgetHandler = () => {
        if(editBudgetModalRef.current) {
            editBudgetModalRef.current.initHandler(projectDetails)
        }
    }

    const multipleTicketEditInit = () => {
        if (checkTicketids.length == 0) {
            toast.error('Please Select atleast one ticket', { position: toast.POSITION.TOP_RIGHT });
        } else {
            if (multipleTicketEditModelRef.current) {
                multipleTicketEditModelRef.current.initModalHandler(checkTicketids);
            }
        }
    }

    const getProjectDetail = (recalculate_project_status = 'N', chart_recreate = 'N') => {
        let params = { need_liking_data: 'Y' };
        if (recalculate_project_status == 'Y') {
            params = { ...params, recalculate_project_status: 'Y' };
        }
        setProject_detail_loading(true)
        HttpAPICall.withAthorization("GET", projectUrl.replace('_replace_id', id), accessToken, params, null, (resp) => {
            setProjectDetails(resp.data.data)
            if (chart_recreate == 'Y' && projectTimeChartRef.current) {
                projectTimeChartRef.current.loadTicketsDataHandler();
            }
        }).then(() => setProject_detail_loading(false));
    }

    const closeTicketView = () => {
        setMinimizeTable(false);
    };

    const addToAllocation = () => {
        let ticketData = ticket_view_data
            ? ticket_view_data
            : null;
        let asset = ticketData && ticketData.asset ? ticketData.asset : "";
        let site_id = ticketData && ticketData.site ? ticketData.site.id : "";
        let obj = {
            asset: asset,
            site_id: site_id,
            ticket_header: ticketData.header,
        };
        localStorage.setItem("selectedTicketToAdd", JSON.stringify(obj));
    };

    const toggleCreateTicket = (type) => {
        setTicketListAddBoard(type);
    };

    const toogleticketDownload = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.ticketDownload();
        }
    };
    const  projectDetailDownLoad =()=>{
        setProject_download_loading(true)
        let params = { download: "download",
            display_ticket : "Y",
            display_expense : "Y",
            display_allocation : "Y",
            display_consumption : "Y",
            display_item_demands : "Y",
            need_liking_data : "Y",
            display_warehouse_indent : "Y",
            display_ticket_work_log  : "Y"
         }
        HttpAPICall.withAthorization("GET", projectUrl.replace('_replace_id', id), accessToken, params, null, (resp) => {
            download.file(resp.data.file_path)
        }).then(() => setProject_download_loading(false));
    }

    const SearchModal = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.ticketSearchModalInit();
        }
    };

    const remarkModal = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.addRemarkModal();
        }
    };

    const DocumentModal = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.addDocumentModal();
        }
    };

    const ticketModal = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.ticketExpenseHandler();
        }
    };

    const updateModal = (id, addFormState) => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.updateTicketModal(id, addFormState);
        }
    };

    const shareTicketModal = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.shareTicketModalInit()
        }
    };

    const downloadTicket = () => {
        if (projectTicketDataRef.current) {
            projectTicketDataRef.current.customModalInit()
        }
    };

    useEffect(() => {
        let newLoadedTabs = loadedTabs.filter((item, i, ar) => ar.indexOf(item) === i);
        newLoadedTabs.push(currentTab);
        setLoadedTabs(newLoadedTabs);
    }, [currentTab]);

    const closeProjectTicket = () => {
        props.history.push("/project");
    };

    let reportTabs = () => {
        const transaction_id = projectDetails ? projectDetails.transaction_id : null;

        const tabs = [
            { name: 'Project Details', jsx: loadedTabs.includes(0) && <ProjectData projectId={id} projectDetails={projectDetails} project_detail_loading={project_detail_loading} /> },
            {
                name: 'Tickets', jsx: loadedTabs.includes(1) && <ProjectTicketData projectDetails={projectDetails} ref={projectTicketDataRef} ticketListAddBoard={ticketListAddBoard} toggleCreateTicket={toggleCreateTicket} checkTicketids={checkTicketids} setCheckTicketids={setCheckTicketids} reportDownloading={reportDownloading}
                    setReportDownloading={setReportDownloading} listing_loading={listing_loading} setListing_loading={setListing_loading} minimizeTable={minimizeTable} setMinimizeTable={setMinimizeTable}
                    ticket_view_data={ticket_view_data} setTicket_view_data={setTicket_view_data} ticketHeader={ticketHeader}
                    setTicketHeader={setTicketHeader} ticketDownloading={ticketDownloading} setTicketDownloading={setTicketDownloading} current_activity_id={current_activity_id} setCurrent_activity_id={setCurrent_activity_id}
                    getProjectDetail={(projectId, recalculate_project_status) => {
                        getProjectDetail(projectId, recalculate_project_status)
                    }}
                />
            },
            { name: 'TimeLine Chart', jsx: loadedTabs.includes(2) && <ProjectTimeLineChart ref={projectTimeChartRef} project_id={transaction_id} /> },
            { name: 'Document', jsx: loadedTabs.includes(3) && <ProjectDocument project_id={transaction_id} /> }]



        if (projectDetails &&
            // projectDetails.count_tickets > 0 &&
            allPermissions?.group_modules?.includes("hrm")) {
            tabs.push({
                name: 'Worklog',
                jsx: loadedTabs.includes(4) && <WorklogList projectWorklog={true} project_id={projectDetails?.id} />
            });
        }

        return tabs;
    }

    const topRightHeaderJsx = () => {
        const setting = ticket_view_data && ticket_view_data.setting ? ticket_view_data.setting : null;
        const id = projectDetails ? projectDetails.id : null;

        return <>

            {currentTab == 0 && <>
                <div className='mt15 d-flex align-items-center justify-content-end text-end'>
                    <button className="btn btn-secondary " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <TapIcon.imageIcon icon={TapIcon.ActionIcon} alt="action-icon" />
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <Link role="button"
                                to={{ pathname: "/project_edit/" + id, state: { projectDetailsData: projectDetails } }}
                                // permissions.includes('iam-project-add') ? '' : 'disabled'
                                className={['dropdown-item',].join(' ')}
                                title={!permissions.includes('iam-project-add') ? 'You dont have permission for this action' : ''}
                                style={{ "pointerEvents": "all" }}
                            >Edit </Link>
                        </li>
                        <li>
                            <Link role="button"
                                onClick={() => { if (true) { return editBudgetHandler() } }}
                                className={['dropdown-item',].join(' ')}
                                style={{ "pointerEvents": "all" }}>
                                Update Budget </Link>

                        </li>
                        <li>
                            <Link role="button" href
                                onClick={() => {
                                    if (permissions.includes('iam-project-delete')) {
                                        deleteProjectHandler();
                                    }
                                }}
                                className={['dropdown-item', permissions.includes('iam-project-delete') ? '' : 'disabled'].join(' ')}
                                title={!permissions.includes('iam-project-delete') ? 'You dont have permission for this action' : ''}
                                style={{ "pointerEvents": "all" }}
                            >Delete</Link>
                        </li>
                    </ul>
                    <button type="button" className="btn btn-secondary" disabled={project_download_loading}
                        onClick={projectDetailDownLoad}>
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                        {project_download_loading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}
                    </button>
                    <button type="button" className="btn btn-secondary" disabled={listing_loading} onClick={() => { refreshData('N') }} >
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-refresh" />
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={closeProjectTicket} >
                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="" alt="item-close" />
                    </button>
                </div>
            </>
            }
            {!minimizeTable &&
                currentTab == 1 && <>
                    <div className='mt15 d-flex align-items-center justify-content-end text-end'>
                        <button type="button" className="btn btn-primary" disabled={permissions.includes('iam-ticket-add') ? false : true} onClick={() => toggleCreateTicket('ticketAdd')}
                        > Create Ticket </button>
                        <button type="button" className="btn btn-secondary"
                            disabled={listing_loading}
                            onClick={SearchModal}
                        >
                            <TapIcon.imageIcon icon={TapIcon.SearchIcon} className="" alt="item-action" />
                        </button>

                        <button type="button" className="btn btn-secondary"
                            disabled={reportDownloading || listing_loading}
                            onClick={toogleticketDownload}>
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                            {reportDownloading && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}
                        </button>
                        <button type="button" className="btn btn-secondary" disabled={listing_loading} onClick={() => { refreshData('Y') }} >
                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-refresh" />
                        </button>
                        <button className="btn btn-secondary " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <TapIcon.imageIcon icon={TapIcon.ActionIcon} alt="action-icon" />
                        </button>
                        <ul className="dropdown-menu">
                            {currentTab == 1 && (<>
                                <li><button type="button" className="dropdown-item" onClick={() => toggleCreateTicket(ticketListAddBoard === 'ticketsBoard' ? 'ticketListShow' : 'ticketsBoard')}>
                                    {ticketListAddBoard === 'ticketsBoard' ? 'Switch to Ticket List' : 'Switch to Ticket Board'}
                                </button>
                                </li>
                                <li>
                                    <Link role="button" href
                                        onClick={() => {
                                            if (permissions.includes('iam-ticket-mutpliple-edit')) {
                                                multipleTicketEditInit();
                                            }
                                        }}
                                        className={['dropdown-item', permissions.includes('iam-ticket-mutpliple-edit') ? '' : 'disabled'].join(' ')}
                                        title={!permissions.includes('iam-ticket-mutpliple-edit') ? 'You dont have permission for this action' : ''}
                                        style={{ "pointerEvents": "all" }}
                                    >Edit Ticket Linking</Link>
                                </li>
                            </>)}
                        </ul>
                        <button type="button" className="btn btn-secondary" onClick={closeProjectTicket} >
                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="" alt="item-close" />
                        </button>
                    </div>
                </>
            }

            {currentTab == 2 && <>
                <div className='mt15 d-flex align-items-center justify-content-end text-end'>
                    <button type="button" className="btn btn-secondary" disabled={listing_loading} onClick={() => { refreshData('N', 'Y') }} >
                        <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-refresh" />
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={closeProjectTicket} >
                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="" alt="item-close" />
                    </button>
                </div>
            </>
            }
            {(currentTab == 3  || currentTab == 4) && <>
                <div className='mt15 d-flex align-items-center justify-content-end text-end'>
                    <button type="button" className="btn btn-secondary" onClick={closeProjectTicket} >
                        <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                    </button>
                </div>
            </>
            }
            {minimizeTable &&
                currentTab == 1 &&
                <div className="row align-items-center justify-content-between  ">
                    <div className="col-6">
                        <h3 className="text-capitalize ">
                            Ticket Header :
                            {ticketHeader.slice(0, 40)}
                            {ticketHeader.length > 40 ? "..." : ""}{" "}
                        </h3>
                    </div>
                    <div className="col-6">
                        <div className="text-end mt15">
                            <button
                                type="button"
                                id="actionMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="btn btn-primary"
                            >
                                Update
                            </button>
                            <ul
                                className="dropdown-menu dropdown-menu-end "
                                aria-labelledby="dropdownMenuButton1"
                            >
                                <li>
                                    <Link
                                        className={["dropdown-item"].join(", ")}
                                        role="button"
                                        onClick={remarkModal}
                                    >
                                        Add Remark
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={["dropdown-item"].join(", ")}
                                        role="button"
                                        onClick={DocumentModal}
                                    >
                                        Add Document
                                    </Link>
                                </li>
                                {setting &&
                                    setting.ticket_expense &&
                                    setting.ticket_expense == "Y" &&
                                    ticket_view_data &&
                                    (ticket_view_data.status !== 26 ||
                                        ticket_view_data !== 10) && (
                                        <li>
                                            <Link
                                                className="dropdown-item"
                                                onClick={ticketModal}>
                                                Add Expense
                                            </Link>
                                        </li>
                                    )}
                                {setting &&
                                    setting.ticket_allocation &&
                                    setting.ticket_allocation == "Y" &&
                                    ticket_view_data &&
                                    (ticket_view_data.status !== 26 ||
                                        ticket_view_data !== 10) && (
                                        <li>
                                            {" "}
                                            <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                role="button"
                                                disabled={
                                                    !permissions.includes(
                                                        "isc-allocation-add"
                                                    )
                                                }
                                                onClick={addToAllocation}
                                                to={{
                                                    pathname: "/allocation_list/add",
                                                    search:
                                                        "?" +
                                                        new URLSearchParams({
                                                            ticketId: ticket_view_data.activity_id
                                                                ? ticket_view_data.activity_id
                                                                : "",
                                                        }).toString(),
                                                }}
                                            >
                                                Add Allocation
                                            </Link>
                                        </li>
                                    )}
                                {setting &&
                                    setting.ticket_consumption &&
                                    setting.ticket_consumption == "Y" &&
                                    ticket_view_data &&
                                    (ticket_view_data.status !== 26 ||
                                        ticket_view_data !== 10) && (
                                        <li>
                                            {" "}
                                            <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                role="button"
                                                disabled={
                                                    !permissions.includes(
                                                        "isc-consumption-add"
                                                    )
                                                }
                                                onClick={addToAllocation}
                                                to={{
                                                    pathname: "/consumption_list/add",
                                                    search:
                                                        "?" +
                                                        new URLSearchParams({
                                                            ticketId: ticket_view_data.activity_id
                                                                ? ticket_view_data.activity_id
                                                                : "",
                                                        }).toString(),
                                                }}
                                            >
                                                Add Consumption
                                            </Link>
                                        </li>
                                    )}
                            </ul>
                            <button
                                type="button"
                                id="shareTicket"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="btn btn-secondary"
                            >
                                <TapIcon.FontAwesomeIcon
                                    icon={TapIcon.faShareAlt}
                                    className="img-fluid"
                                    alt="item-action"
                                />
                            </button>
                            <ul
                                className="dropdown-menu dropdown-menu-end"
                                aria-labelledby="shareTicket"
                            >
                                <li>
                                    <Link
                                        className="dropdown-item"
                                        role="button"
                                        onClick={shareTicketModal}
                                    >
                                        Share by Email
                                    </Link>
                                </li>
                            </ul>

                            <button
                                type="button"
                                id="actionMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="btn btn-secondary"
                            >
                                <TapIcon.imageIcon
                                    icon={TapIcon.ActionIcon}
                                    className="img-fluid"
                                    alt="item-action"
                                />
                            </button>
                            <ul
                                className="dropdown-menu dropdown-menu-end "
                                aria-labelledby="dropdownMenuButton1"
                            >
                                <li>
                                    <Link
                                        className={[
                                            ticket_view_data?.can_edit == "N"
                                                ? "disabled dropdown-item"
                                                : "dropdown-item",
                                        ].join(", ")}
                                        role="button"
                                        onClick={() =>
                                            updateModal(
                                                ticket_view_data?.activity_id,
                                                "detail"
                                            )
                                        }
                                    >
                                        Edit Detail
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={[
                                            ticket_view_data?.can_edit == "N"
                                                ? "disabled dropdown-item"
                                                : "dropdown-item",
                                        ].join(", ")}
                                        role="button"
                                        onClick={() =>
                                            updateModal(
                                                ticket_view_data?.activity_id,
                                                "tagging_detail"
                                            )
                                        }
                                    >
                                        Edit Tagging Detail
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className={[
                                            ticket_view_data?.can_edit == "N"
                                                ? "disabled dropdown-item"
                                                : "dropdown-item",
                                        ].join(", ")}
                                        role="button"
                                        onClick={() =>
                                            updateModal(
                                                ticket_view_data?.activity_id,
                                                "other_detail"
                                            )
                                        }
                                    >
                                        Edit Other Detail
                                    </Link>
                                </li>
                            </ul>
                            <button
                                disabled={ticketDownloading}
                                onClick={() =>
                                    downloadTicket(
                                        current_activity_id
                                    )
                                }
                                type="button"
                                className="btn btn-secondary"
                            >
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                {ticketDownloading ? (
                                    <TapIcon.FontAwesomeIcon
                                        icon={TapIcon.faSyncAlt}
                                        className="fa-spin"
                                    />
                                ) : (
                                    ""
                                )}
                            </button>
                            <button onClick={closeTicketView} type="button" className="btn btn-secondary" >
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className=" " alt="item-close" />
                            </button>
                        </div>
                    </div>

                </div>
            }
        </>
    }

    const pageHeading = () => {
        return <>

            <Helmet><title>Project Detail</title></Helmet>
            <div className="page_title m0 row ">
                <div className='col-sm-12'>
                    <div className='row'>
                        <div className={minimizeTable ? "col-sm-3" : 'col-sm-6'}>
                            <h3 className='mb-0'>Project : {projectDetails?.name}</h3>
                        </div>
                        <div className={minimizeTable ? "col-sm-9 tap_border_left " : 'col-sm-6 d-flex justify-content-end align-items-center'}>
                            {topRightHeaderJsx()}
                        </div>
                    </div>
                </div>
            </div>
        </>

    }

    return <ApplicationLayout>
        {pageHeading()}
        <div className="container-fluid pl5">
            <div className=' row'>
                <div className='col-sm-12 bg-white mt-1'>
                    <TapNavTabs
                        tabReinitialize="N"
                        tabs={reportTabs()}
                        activetab={0}
                        setTabValue={(activetab) => { setCurrentTab(activetab); }}
                        noHeaderClass={true}
                    />
                </div>
            </div>
        </div>
        <UpdateMultipleTicketModal
            afterSucess={() => {
                refreshData('Y','N')
                setCheckTicketids([])
            }}
            site_id={projectDetails && projectDetails.site ? projectDetails.site.id : null}
            ref={multipleTicketEditModelRef}
        />
        <ProjectEditModal ref={editProjectModalRef} getProjectDetail={getProjectDetail} />
        <EditBudgetModal ref={editBudgetModalRef} getProjectDetail={getProjectDetail} />
        
    </ApplicationLayout>
});


export default ProjectDetail;